import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PDFExportPanel from "../../Common/pdfExporter/pdfDownloadButton";
import EditDeleteColumn from "../Common/EditDeleteColumn";
import ListViewGeneric from "../Common/ListViewGeneric";
import MrMonthComponent from "../Common/MrMonthComponent";

const getColumns = (link, table) => [
  {
    field: "date",
    headerName: "Date",
    formLayoutAttr: {
      row: 1,
      inputProps: { disabled: true },
    },
    gridLayoutAttr: {
      valueGetter: (d) =>
        d.data.date ? new Date(d.data.date).toDateString() : "",
    },
  },
  {
    field: "name",
    headerName: "Track Name",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  {
    field: "dailyAllowance",
    headerName: "Daily Allowence",
    formLayoutAttr: {
      row: 1,
    },
    gridLayoutAttr: {},
  },
  // {
  //   field: "expense",
  //   headerName: "Expense",
  //   formLayoutAttr: {
  //     row: 1,
  //   },
  //   gridLayoutAttr: {},
  // },
  {
    field: "fare",
    headerName: "Fare",
    formLayoutAttr: {
      row: 1,
      type: "number",
    },
    gridLayoutAttr: { style: { flex: 5 } },
  },
  {
    field: "exExp",
    headerName: "Extra Expenses",
    formLayoutAttr: {
      row: 1,
      type: "number",
    },
    gridLayoutAttr: {},
  },
  {
    field: "total",
    headerName: "Total",
    formLayoutAttr: {
      row: 1,
      type: "number",
    },
    gridLayoutAttr: {},
  },
];

function List(props) {
  const { label, table, link, userDetails } = props;
  const [listData, setListData] = useState([]);
  const location = useLocation();
  const [mr, setMr] = useState({});
  const [month, setMonth] = useState();
  const [pinnedRowTotal, setPinnedRowTotal] = useState({});

  useEffect(() => {
    setListData([]);
    function fetchData(d) {
      let alreadyAdded = [];
      let totalRow = {
        srNo: "",
        dailyAllowance: 0,
        fare: 0,
        exExp: 0,
        total: 0,
        name: "Total",
      };
      axios
        .get(
          `/getExpenseReport.php?where=dr.mrId=${
            userDetails.role === "admin" ? mr : userDetails.id
          } and dr.date between ${month} `
        )
        .then((res) => {
          let abc = {};
          let date_track = {};
          let dailyAllowance = {};
          (res.data || []).forEach((element) => {
            // console.log(res.data);
            if (element.name) {
              if (!abc[element.name + element.date]) {
                // console.log(parseFloat(element.petrol_dr) , parseFloat(element.km));

                abc[element.name + element.date] = {
                  ...element,
                  dailyAllowance: !dailyAllowance[element.date]
                    ? parseFloat(element.dailyAllowance)
                    : null,
                  fare: parseFloat(element.petrol_dr) * parseFloat(element.km),
                  exExp: parseFloat(element.exExp),
                };
                dailyAllowance[element.date] = true;
              } else {
                abc[element.name + element.date].exExp += parseFloat(
                  element.exExp
                );
              }
              abc[element.name + element.date].total =
                (abc[element.name + element.date].dailyAllowance ?? 0) +
                abc[element.name + element.date].fare +
                abc[element.name + element.date].exExp;
              console.log(abc[element.name + element.date].dailyAllowance);
              if (!date_track[element.name + element.date]) {
                totalRow.dailyAllowance =
                  parseFloat(totalRow.dailyAllowance) +
                  parseFloat(
                    abc[element.name + element.date].dailyAllowance ?? 0
                  );
                date_track[element.name + element.date] = true;
                totalRow.fare =
                  parseFloat(totalRow.fare) +
                  parseFloat(abc[element.name + element.date].fare);
              }
              totalRow.exExp =
                parseFloat(totalRow.exExp) +
                parseFloat(abc[element.name + element.date].exExp);
            }
          });
          totalRow.total =
            parseFloat(totalRow.dailyAllowance) +
            parseFloat(totalRow.fare) +
            parseFloat(totalRow.exExp);
          setPinnedRowTotal(totalRow);
          setListData(Object.values(abc));
        })
        .catch((err) => console.log(err));
    }
    if (userDetails.id && (userDetails.role !== "admin" || mr) && month) {
      axios.get(`/get.php?name=city`).then(({ data }) => {
        let c = {};
        data.forEach((k) => (c[k.id] = k));
        fetchData(c);
      });
    }
  }, [table, userDetails.id, location.key, mr, month]);

  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [mrDetails, setMrDetails] = useState();

  const onGridReady = (params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  };
  return (
    <>
      <MrMonthComponent
        mr={mr}
        month={month}
        role={userDetails.role}
        setMonth={setMonth}
        setMr={setMr}
        setMrDetails={setMrDetails}
      />
      <PDFExportPanel
        gridApi={gridApi}
        columnApi={columnApi}
        heading={`Expense Report for ${mrDetails?.mrName} in headquarter ${mrDetails?.headQuarter} between ${month}`}
      />
      <ListViewGeneric
        title={"Report"}
        data={listData}
        otherAgGridProps={{
          pinnedBottomRowData: [pinnedRowTotal],
          onGridReady,
        }}
        noNew={true}
        link={link}
        columns={getColumns(link, table)}
      />
    </>
    // <>{JSON.stringify(listData)}</>
  );
}

export default List;
